module.exports = __webpack_public_path__ + "img/wani.516dfc9b.png";